import type { ParsedListingFilters } from '@/features/seo-listing/types';
import type { FilterState } from '../../store';

/**
 * Compares restored SEO filters with the current filter state BY CONTENT, not
 * by reference. parseListingGetUrl always returns fresh arrays; dispatching
 * them with identical content would re-trigger the fanfics load effect (it
 * depends on these arrays by reference) and cause a duplicate request.
 */
export const hasRestoredListingFiltersChanged = (
  restoredFilters: ParsedListingFilters,
  currentFilters: FilterState,
): boolean =>
  JSON.stringify(restoredFilters.fandoms) !== JSON.stringify(currentFilters.selectedFandoms) ||
  JSON.stringify(restoredFilters.tags) !== JSON.stringify(currentFilters.selectedTags) ||
  JSON.stringify(restoredFilters.universes) !== JSON.stringify(currentFilters.selectedUniverses) ||
  JSON.stringify(restoredFilters.statuses) !== JSON.stringify(currentFilters.selectedStatuses) ||
  JSON.stringify(restoredFilters.ratings) !== JSON.stringify(currentFilters.selectedRatings) ||
  JSON.stringify(restoredFilters.characters) !==
    JSON.stringify(currentFilters.selectedCharacters) ||
  JSON.stringify(restoredFilters.pairingCharacters) !==
    JSON.stringify(currentFilters.selectedPairingCharacters);
